// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html, #root, .app {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: 'Helvetica', sans-serif;
}

.no-scroll {
    overflow: hidden;
}

.app {
    position: relative;
    -webkit-user-select: none;
            user-select: none;
}

.sections {
    display: flex;
    flex-direction: column;
    height: 300vh;
    will-change: transform;
}

.section {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
}

.background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.logo {
    max-width: 850px;
    height: auto;
    -webkit-user-select: none;
            user-select: none;
}

.corner-logo {
  -webkit-user-select: none;
          user-select: none;
    max-width: 250px;
    height: auto;
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.section-title {
    /* font-family: "Merriweather", serif; */
    font-family: "Bona Nova SC", serif;
    position: relative;
    font-size: 5rem;
    text-align: center;
    color: white;
    z-index: 2;
    padding: 0.25em 0;
    -webkit-user-select: none;
            user-select: none;
}

.section-text {
    z-index: 2;
    color: white;
    text-align: center;
    font-size: 2em;
    -webkit-user-select: none;
            user-select: none;
    max-width: 30em;
}

.content {
    z-index: 1;
    text-align: center;
    color: white;
    position: relative;
}

.indicator {
    position: fixed;
    top: 50%;
    right: 2%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: whitesmoke;
    margin-bottom: 10px;
    cursor: pointer;
    transition: transform 0.2s ease, background-color 0.2s ease;
}

.dot.active {
    background-color: red;
}

.dot:hover {
    transform: scale(1.4);
}

.custom-button {
    -webkit-user-select: none;
            user-select: none;
    background-color: transparent;
    color: white;
    border: 3.5px solid red;
    padding: 10px 20px;
    font-size: 1rem;
    margin-top: 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.custom-button:hover {
    background-color: red;
}

.social-icon {
    margin: 0 10px;
    transition: transform 0.3s ease, color 0.3s ease;
    background: none;
    border: none;
    cursor: pointer;
}

.social-icon:hover {
    transform: scale(1.1);
    /* color: #ddd; */
}

.instagram-icon {
  color: #E4405F;
}

.facebook-icon {
  color: #1877F2;
}

.contact-icon { 
  color: goldenrod;
}

.icon-container {
    margin-top: 20px;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: rgba(255, 255, 255, 0.92);
    padding: 20px;
    border-radius: 10px;
    max-width: 500px;
    width: 80%;
    position: relative;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.hr-arp, .hr-cf {
  height: 2px;
  background-color: white;
  border: 0;
}

.hr-arp {
  max-width:30em;
}

.hr-cf {
  max-width:50em;
}

@media (max-width: 768px) {
    .logo {
        max-width: 80%;
    }

    .section-title {
        font-size: 1.9rem; 
        padding: .1em;
    }

    .section-text {
        font-size: 1.2rem; 
        max-width: 20em;
    }

    .hr-arp {
      max-width:19em;
    }
    
    .hr-cf {
      max-width:20em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gDAAgD;IAChD,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;AACJ","sourcesContent":["body, html, #root, .app {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    font-family: 'Helvetica', sans-serif;\n}\n\n.no-scroll {\n    overflow: hidden;\n}\n\n.app {\n    position: relative;\n    user-select: none;\n}\n\n.sections {\n    display: flex;\n    flex-direction: column;\n    height: 300vh;\n    will-change: transform;\n}\n\n.section {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100vw;\n}\n\n.background-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.logo {\n    max-width: 850px;\n    height: auto;\n    user-select: none;\n}\n\n.corner-logo {\n  user-select: none;\n    max-width: 250px;\n    height: auto;\n    position: absolute;\n    top: 50px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 10;\n}\n\n.section-title {\n    /* font-family: \"Merriweather\", serif; */\n    font-family: \"Bona Nova SC\", serif;\n    position: relative;\n    font-size: 5rem;\n    text-align: center;\n    color: white;\n    z-index: 2;\n    padding: 0.25em 0;\n    user-select: none;\n}\n\n.section-text {\n    z-index: 2;\n    color: white;\n    text-align: center;\n    font-size: 2em;\n    user-select: none;\n    max-width: 30em;\n}\n\n.content {\n    z-index: 1;\n    text-align: center;\n    color: white;\n    position: relative;\n}\n\n.indicator {\n    position: fixed;\n    top: 50%;\n    right: 2%;\n    transform: translateY(-50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background-color: whitesmoke;\n    margin-bottom: 10px;\n    cursor: pointer;\n    transition: transform 0.2s ease, background-color 0.2s ease;\n}\n\n.dot.active {\n    background-color: red;\n}\n\n.dot:hover {\n    transform: scale(1.4);\n}\n\n.custom-button {\n    user-select: none;\n    background-color: transparent;\n    color: white;\n    border: 3.5px solid red;\n    padding: 10px 20px;\n    font-size: 1rem;\n    margin-top: 20px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.custom-button:hover {\n    background-color: red;\n}\n\n.social-icon {\n    margin: 0 10px;\n    transition: transform 0.3s ease, color 0.3s ease;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.social-icon:hover {\n    transform: scale(1.1);\n    /* color: #ddd; */\n}\n\n.instagram-icon {\n  color: #E4405F;\n}\n\n.facebook-icon {\n  color: #1877F2;\n}\n\n.contact-icon { \n  color: goldenrod;\n}\n\n.icon-container {\n    margin-top: 20px;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: rgba(255, 255, 255, 0.92);\n    padding: 20px;\n    border-radius: 10px;\n    max-width: 500px;\n    width: 80%;\n    position: relative;\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n}\n\n.hr-arp, .hr-cf {\n  height: 2px;\n  background-color: white;\n  border: 0;\n}\n\n.hr-arp {\n  max-width:30em;\n}\n\n.hr-cf {\n  max-width:50em;\n}\n\n@media (max-width: 768px) {\n    .logo {\n        max-width: 80%;\n    }\n\n    .section-title {\n        font-size: 1.9rem; \n        padding: .1em;\n    }\n\n    .section-text {\n        font-size: 1.2rem; \n        max-width: 20em;\n    }\n\n    .hr-arp {\n      max-width:19em;\n    }\n    \n    .hr-cf {\n      max-width:20em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
